<template>
  <ValidationProvider
    :vid="vid"
    :mode="mode"
    :name="String(_uid)"
    :rules="rules"
    v-slot="{ errors, valid }"
  >
    <v-autocomplete
      :class="`${customClass} ${requiredClassByRules()}`"
      :items="items"
      v-model="innerValue"
      :error-messages="errors"
      :success="valid"
      v-bind="$attrs"
      v-on="$listeners"
      :data-cy-validation-result="errors.length ? rulesToString() : false"
    ></v-autocomplete>
  </ValidationProvider>
</template>

<script>
import { validationMixin } from '../mixins/validation';

export default {
  mixins: [validationMixin],
  props: {
    rules: {
      type: [Object, String],
      default: '',
    },
    // must be included in props
    value: {
      type: null,
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    customClass: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: 'aggressive',
    },
    vid: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    innerValue: '',
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit('input', newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
};
</script>
